import { Box } from "@mui/material";

import { HEADER_HEIGHT, TAB_BAR_HEIGHT } from "../constants";

interface TabGroupResizeHandleProps {
  tabGroupPosition: { x: number; y: number };
  tabGroupSize: { width: number; height: number };
  onResizeStart: (event: React.PointerEvent) => void;
  onResizeMove: (event: React.PointerEvent) => void;
  onResizeEnd: (event: React.PointerEvent) => void;
}

export function TabGroupResizeHandle({
  tabGroupPosition,
  tabGroupSize,
  onResizeStart,
  onResizeMove,
  onResizeEnd,
}: TabGroupResizeHandleProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        left: tabGroupPosition.x + tabGroupSize.width - 16,
        top: tabGroupPosition.y + HEADER_HEIGHT + TAB_BAR_HEIGHT + tabGroupSize.height - 16,
        width: 16,
        height: 16,
        cursor: "nwse-resize",
        zIndex: (theme) => theme.zIndex.modal + 57,
        pointerEvents: "auto",
        "&::after": {
          content: '""',
          position: "absolute",
          right: 3,
          bottom: 3,
          width: 8,
          height: 8,
          borderRight: "2px solid",
          borderBottom: "2px solid",
          borderColor: "grey.400",
        },
      }}
      onPointerDown={onResizeStart}
      onPointerMove={onResizeMove}
      onPointerUp={onResizeEnd}
    />
  );
}
